// Generated by ts-to-zod
import {z} from "zod";

export const mantineAlertPropsSchema = z.object({
	title: z.string().optional(),
});
